module.exports = __webpack_public_path__ + "assets/images/stopwatch--emerald.svg?1094eae738b4237c89345de82fd72d41";


//////////////////
// WEBPACK FOOTER
// ./_source/images/notifications/stopwatch--emerald.svg
// module id = 633
// module chunks = 0